import React, { useContext } from 'react';

import { Descriptions, DescriptionsProps, Flex } from 'antd';
import { useGetOrganizationByIdQuery } from 'src/redux/services/centralApi';
import DashboardTemplate from 'src/templates/DashboardTemplate';
import { AuthContext } from 'src/AuthProvider';
import ListUsers from 'src/pages/administration/ListUsers';
import CreateUserLink from 'src/pages/administration/OrganizationsPage/components/CreateUserLink';

export default function OrganizationPage() {
	const { user, } = useContext(AuthContext);

	const {
		data: organizationData,
	} = useGetOrganizationByIdQuery(user?.org_id ?? '');

	const items: DescriptionsProps['items'] = [
		{
			key: '1',
			label: 'Nome',
			span: 2,
			children: organizationData?.name,
		},
		{
			key: '2',
			label: 'ID',
			span: 2,
			children: organizationData?.id,
		},
		{
			key: '3',
			label: 'Token',
			span: 4,
			children: organizationData?.jwt,
		},
		{
			key: '4',
			label: <Flex justify="space-between" align="center" style={{ width: '100%', }}>
				Usuários
				<CreateUserLink orgId={organizationData?.id ?? ''} />
			</Flex>,
			span: 4,
			children: <div style={{ width: '100%', }}>
				<ListUsers users={organizationData?.users ?? []} />
			</div>,
		},
	];

	return (
		<DashboardTemplate pageTitle="Gerenciar Organização">
			<Descriptions title='Informações da organização' size='small' layout='vertical' bordered items={items} />
		</DashboardTemplate>
	);
}
